import request from '@/router/axios'

export function getMaterialTagList(params) {
  return request({
    url: '/basic/admin/material-tag/page',
    method: 'GET',
    params: params
  })
}

export function deleteMaterialTag(ids) {
    return request({
        url: '/basic/admin/material-tag',
        method: 'DELETE',
        params: {
            ids: ids
        }
    })
}

export function addObj (obj) {
    return request({
      url: '/basic/admin/material-tag',
      method: 'post',
      data: obj
    })
}

export function putObj (obj) {
    return request({
      url: '/basic/admin/material-tag/edit',
      method: 'post',
      data: obj
    })
}

export function getTagRelationList() {
  return request({
    url: '/basic/admin/material-tag/relation',
    method: 'GET'
  })
}